import React from 'react'
import Button from '../../../components/Button'
import { useHistory } from 'react-router-dom'
import styles from './JobNavigation.sass'

interface JobNavigationProps {
  onPrevious?: () => void
  next?: string
  canProceed?: boolean
}

export default function JobNavigation({
  onPrevious,
  next,
  canProceed,
}: JobNavigationProps) {
  const navigation = useHistory()

  return (
    <div className={styles.root}>
      <div className={styles.buttonContainer}>
        {onPrevious && (
          <Button type="secondary" onClick={onPrevious}>
            Previous
          </Button>
        )}
      </div>

      <div className={styles.buttonContainer}>
        {next && (
          <Button
            onClick={() => navigation.push(next)}
            disabled={!canProceed}
            type="primary"
          >
            Next
          </Button>
        )}
      </div>
    </div>
  )
}
